module.exports = __webpack_public_path__ + "assets1733911544048/img/lan4.5dcca9c1.png";